import { render, staticRenderFns } from "./AddDiscountTransaction.vue?vue&type=template&id=c819cedc"
import script from "./AddDiscountTransaction.vue?vue&type=script&lang=js"
export * from "./AddDiscountTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports